import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasPetsLabel',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class HasPetsLabelPipe implements PipeTransform {
  transform(value: boolean | null | undefined | ''): string {
    if (value === true) {
      return 'Yes';
    } else if (value === false) {
      return 'No';
    } else {
      return 'Unknown';
    }
  }
}
